import React from 'react'
import styled from 'styled-components'

const StyledSVG = styled.svg`
  path {
    fill: ${({ theme, color }) => theme.colors[color]};
    stroke: ${({ theme, color }) => theme.colors[color]};
  }
`

const LogoutIcon = ({ color = 'primaryDark' }) => {
    return (
        <StyledSVG
          width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginLeft:'12px'}}>
          <path d="M2.3077 17.5C1.80257 17.5 1.375 17.325 1.025 16.975C0.675 16.625 0.5 16.1974 0.5 15.6923V2.3077C0.5 1.80257 0.675 1.375 1.025 1.025C1.375 0.675 1.80257 0.5 2.3077 0.5H9.0096V1.99998H2.3077C2.23077 1.99998 2.16024 2.03203 2.09612 2.09613C2.03202 2.16024 1.99997 2.23077 1.99997 2.3077V15.6923C1.99997 15.7692 2.03202 15.8397 2.09612 15.9038C2.16024 15.9679 2.23077 16 2.3077 16H9.0096V17.5H2.3077ZM13.2308 13.2692L12.1923 12.1846L14.6269 9.74995H6.09613V8.25H14.6269L12.1923 5.81538L13.2308 4.7308L17.5 8.99998L13.2308 13.2692Z" fill="#475468"/>
        </StyledSVG>

    )
}

export default LogoutIcon
